import { createFetch } from "@convergence/client";

export const fetch = createFetch(import.meta.env.VITE_API_ENDPOINT as string);